export enum Frequency {
  Once = 'once',
  Hour = 'hour',
  Monthly = 'month',
  Annually = 'year'
}

export default Frequency;
